import * as type from './types';

export function activateChatBox(data) {
    return {
        type: type.ACTIVATE_CHATBOX_SUCCESS,
        data: data,
    }
}